import React, { useEffect, useState } from 'react';
import { Card, Row, Form, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import userAccessProjectParticipationsService from '@rd-web-markets/shared/dist/services/user_access_project_participations.service';
import { Loading } from '@rd-web-markets/shared/dist/util';
import CreateUserAccessModal from '@rd-web-markets/market/dist/claim_schedule_engagement_team/CreateUserAccessModal';
import { AddButton, MarketDeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
import ImmutableUnderReviewFormCheck from '../util/reviewEditControls/ImmutableUnderReviewFormCheck';
import userAccessService from '../services/user_access.service';
import UserSelectorRow from './UserSelectorRow';
import { getSelectableUserAccessDropdownOptions } from '../util/user/userUtils';
const ContactsSection = _ref => {
  let {
    report,
    claimGroup,
    setClaimGroup,
    company,
    canEdit = true
  } = _ref;
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [selectedUserAccess, setSelectedUserAccess] = useState(null);
  const [createModalShow, setCreateModalShow] = useState(false);
  const [participations, setParticipations] = userAccessProjectParticipationsService.useParticipations(report.id);
  const deleteParticipation = userAccessProjectParticipationsService.useDeleteParticipation(report.id, setParticipations);
  const updateUserAccess = userAccessService.useUpdateUserAccess(claimGroup, setClaimGroup, setLoading);
  const submitUserAccessProjectParticipation = userAccessProjectParticipationsService.useSubmitUserAccessProjectParticipation(report.id, setParticipations, setSelectedUserAccess);
  const updateUserAccessEngagementTeam = (participations, participation, e) => {
    const userAccess = participation.user_access;
    const updatedUserAccess = {
      ...userAccess,
      [e.target.name]: e.target.checked
    };
    updateUserAccess(updatedUserAccess);
    const filteredParticipations = participations?.filter(p => p.id != participation.id);
    participation.user_access = updatedUserAccess;
    setParticipations([...filteredParticipations, participation]);
  };
  const changeParticipationEngagementTeam = (selectedUserAccess, e) => {
    setSelectedUserAccess({
      ...selectedUserAccess,
      included_in_engagement_team: e.target.checked
    });
  };
  const changeSelectedUserAccessOption = e => {
    const value = e.value;
    if (!value) {
      setSelectedUserAccess(null);
      return;
    }
    const found = claimGroup.user_accesses.find(user_access => Number(user_access.id) === Number(value));
    setSelectedUserAccess({
      user_access_id: value,
      ...found
    });
  };
  useEffect(() => {
    if (!selectedUserAccess || selectedUserAccess?.user) return;
    const id = selectedUserAccess.id ?? selectedUserAccess.user_access_id;
    const found = claimGroup.user_accesses.find(ua => Number(ua.id) === Number(id));
    if (found) setSelectedUserAccess(found);
  }, [claimGroup.user_accesses, selectedUserAccess?.id, selectedUserAccess?.user_access_id, selectedUserAccess?.user]);
  const createUserAccess = userAccessService.useCreateUserAccess(claimGroup, setLoading, setClaimGroup, setSelectedUserAccess, undefined);
  if (!participations) return /*#__PURE__*/React.createElement(Loading, null);
  const userAccessOptions = getSelectableUserAccessDropdownOptions(claimGroup, participations);
  return /*#__PURE__*/React.createElement(React.Fragment, null, canEdit && /*#__PURE__*/React.createElement(CreateUserAccessModal, {
    title: 'add_contact',
    onHide: () => setCreateModalShow(false),
    show: createModalShow,
    onSubmit: createUserAccess,
    company: company,
    claimGroup: claimGroup
  }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md fw-bold",
    md: 10
  }, t('client_contacts')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement("div", {
    className: "justify-content-end d-flex"
  }, canEdit && /*#__PURE__*/React.createElement(AddButton, {
    variant: "primary",
    onClick: () => setCreateModalShow(true),
    text: t('add_contact')
  }))))), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("table", {
    className: "table borderless"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("th", null, t('name')), /*#__PURE__*/React.createElement("th", null, t('role')), /*#__PURE__*/React.createElement("th", null, t('email')), /*#__PURE__*/React.createElement("th", null, t('_num')), /*#__PURE__*/React.createElement("th", null, t('engagement_team')), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", {
    className: "text-center"
  }, participations.map(participation => {
    const rolesTranslated = participation.user_access.roles.map(r => t(r));
    return /*#__PURE__*/React.createElement("tr", {
      key: participation.user_access.id
    }, /*#__PURE__*/React.createElement("td", null, participation.user_access.user.name), /*#__PURE__*/React.createElement("td", null, rolesTranslated.join(',')), /*#__PURE__*/React.createElement("td", null, participation.user_access.user.email), /*#__PURE__*/React.createElement("td", null, participation.user_access.user.phone_number), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormCheck, {
      value: participation.user_access.included_in_engagement_team,
      checked: participation.user_access.included_in_engagement_team,
      name: "included_in_engagement_team",
      onChange: e => updateUserAccessEngagementTeam(participations, participation, e),
      disabled: !canEdit
    })), /*#__PURE__*/React.createElement("td", null, canEdit && /*#__PURE__*/React.createElement(MarketDeleteButton, {
      onClick: () => deleteParticipation(participation, participations),
      className: "mx-2",
      variant: "danger"
    })));
  }), canEdit && /*#__PURE__*/React.createElement(UserSelectorRow, {
    userAccessOptions: userAccessOptions,
    selectedUserAccess: selectedUserAccess,
    onSelectionChange: changeSelectedUserAccessOption,
    onEngagementTeamChange: changeParticipationEngagementTeam,
    onSubmit: submitUserAccessProjectParticipation,
    participations: participations
  })))))));
};
export default ContactsSection;